<template>
  <div v-loading="loading" class="rule-box">
    <div class="title">{{ info.title }}</div>
    <div v-html="info.contents"></div>
  </div>
</template>

<script>
import { getagreement } from '@/api/home';
export default {
  data() {
    return {
      info: {},
      loading: false
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    async getInfo() {
      this.loading = true
      getagreement({
        keyword: 'pointdockey'
      }).then(({ data }) => {
        this.loading = false
        this.info = data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.rule-box {
  background-color: #fff;
  margin-bottom: 25px;
  min-height: 700px;
  border-radius: 12px;
  padding: 20px;
  .title {
    text-align: center;
    font-size: 16px;
    color: #333;
    padding: 10px 0 30px;
    font-weight: 550;
  }
}

</style>